<template>
  <div class="window">
    <a class="Back-Container">
      <simple-header :label="$t('global.back')" @click="$router.back()" />
    </a>

    <div class="container">
      <div class="row">
        <vv-form-select-input already-translated v-model="locale" :options="availableLocales" />
      </div>
      <br />
      <div class="row">
        <vv-button @click="save">{{ $t('global.save') }}</vv-button>
      </div>
    </div>
  </div>
</template>

<script>
import { UPDATE_USER_INFORMATIONS } from '@/store/modules/user/types'
import userMixin from '@/mixins/user'
import remoteConfigMixin from '@/mixins/remoteConfig'
import { VvButton } from '@/components/common'
import VvFormSelectInput from '@/components/common/forms/VvFormSelectInput'
import SimpleHeader from '@/components/navigation/SimpleHeader'

export default {
  name: 'Language',
  components: { VvButton, VvFormSelectInput, SimpleHeader },
  mixins: [userMixin, remoteConfigMixin],
  data() {
    return {
      locale: ''
    }
  },
  computed: {
    availableLocales() {
      const languages = this.remoteConfig.getString('languages')

      if (languages) {
        return languages
          .split('|')
          .map(language => ({ value: language, text: this.$t(`languages.${language}`) }))
      }

      return []
    }
  },
  mounted() {
    if (this.user.language) {
      this.locale = this.user.language

      return
    }

    const browserLocale = navigator.language || navigator.browserLanguage
    const localeMatch = this.availableLocales.find(({ value }) => value === browserLocale)

    this.locale = localeMatch ? localeMatch.value : 'fr-FR'
  },
  methods: {
    async save() {
      await this.$store.dispatch(UPDATE_USER_INFORMATIONS, {
        language: this.locale
      })

      await this.$store.dispatch('SYNC_DATA', { locale: this.locale })

      const i18nLocaleMapping = {
        'en-US': 'en',
        'fr-FR': 'fr'
      }

      this.$root.$i18n.locale = i18nLocaleMapping[this.locale]
      if (this.$validator.dictionary.hasLocale(i18nLocaleMapping[this.locale])) {
        this.$validator.localize(i18nLocaleMapping[this.locale])
      } else {
        import(`vee-validate/dist/locale/${i18nLocaleMapping[this.locale]}`).then(locale => {
          this.$validator.localize(i18nLocaleMapping[this.locale], locale)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.window {
  position: absolute;
  top: 150px;
  right: 40%;
  padding: 10px;
  background-color: rgb(230, 233, 233);
  border-radius: 10px;
}

.container .row {
  margin: auto;
  text-align: center;
}

@media (max-width: 1024px) {
  .Back-Container {
    display: none;
  }
}
</style>
